<template>
  <div class="mcat-wrapper">
    <div class="mcat-top">
      <b-button class="mcat-top-btn" @click="$bvModal.show(`add-item`)" variant="link">Add Item</b-button>
    </div>
    <div v-if="items !==null" class="items-wrapper">
      <template v-for="(item,index) in items">
        <ItemCard :key="index" :menuId="menuId" :item="item" :editable="true" />
      </template>
    </div>
    
    <div v-else class="no-data">There are no items in this category yet. Click below to add item</div>
    <validation-observer v-slot="{invalid}">
      <b-modal
        :ok-disabled="invalid"
        @ok="addItem"
        id="add-item"
        size="md"
        title="Create Item"
      >
        <form action>
          <TextInput
            :rules="`required`"
            placeholder="Item Name"
            v-model="form.name"
          />
          <TextInput placeholder="Description" v-model="form.description" />
          <TextInput :rules="'required'" placeholder="Price" v-model="form.price" />
          <b-form-tags
            input-id="tags-pills"
            v-model="form.tags"
            tag-variant="primary"
            tag-pills
            size="lg"
            separator=" "
            remove-on-delete
            class="mb-2"
          ></b-form-tags>
          <FileUpload
            :onfile="fileChange"
            :value="file"
            :isLoading="fileLoading"
            @changed="fileChange($event)"
            label="upload item image"
            fileTypes="PNG up to 5MB"
            :progress="progress"
            :deleteFile="deleteFile"
          />
        </form>
      </b-modal>
    </validation-observer>
  </div>
</template>

<script>
import { auth } from "../Firebase/firebase";
import ItemCard from "./components/ItemCard";
import TextInput from "./components/Inputs/TextInput";
import FileUpload from "./components/DragDropFileInput";
import { ValidationObserver } from "vee-validate";
export default {
  props: {},
  components: {
    ItemCard,
    TextInput,
    FileUpload,
    ValidationObserver
  },
  data() {
    return {
      category: this.$route.params.category_title,
      menuId: this.$route.params.menuId,
      form: {},
      categoryEdit: {},
      file: [],
      formValues: "",
      fileLoading: false,
    };
  },
  methods: {
    fileChange(file) {
      const formData = new FormData();
      formData.append("csvUpload", file);
      const formValues = formData;
      this.file = file;
    },
    deleteFile(index, item) {
      const tempFiles = [...this.file];
      tempFiles.splice(index, 1);
      this.file = [...tempFiles];
    },

    addItem(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$store
        .dispatch("Item/createItem", {
          file: this.file,
          userId: auth.currentUser.uid,
          form: this.form
        })
        .then(() => {
          this.$bvModal.hide('add-item');
        });
    },
    getItems(limit,query='') {
      this.$store.dispatch("Item/fetchItems", {
        userId: auth.currentUser.uid,
        limit,
        query
      })
    },
  },
  computed: {
    items() {
      return this.$store.state.Item.items
    },
    currentCategory() {
      return this.$store.state.Menu.currentCategory;
    },
    progress() {
      return this.$store.state.Menu.uploadValue;
    },
  },
  mounted() {
    this.getItems(20)
  }
};
</script>

<style scoped>
.mcat-wrapper .mcat-top {
  display: flex;
  justify-content: flex-end;
}
.mcat-wrapper .mcat-top .mcat-top-btn {
  color: #2ca8ff;
  margin: 0;
  padding: 0 10px;
}

.mcat-wrapper .mcat-top .mcat-top-btn:hover {
  color: #2ca8ff;
}

.mcat-wrapper .items-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fit,minmax(250px,1fr));
  grid-gap: 10px;
}

.mcat-wrapper .cat-title {
  font-weight: bold;
  font-size: 18px;
  line-height: 20px;
  /* identical to box height, or 111% */

  color: #000000;
  margin-bottom: 25px;
}
</style>